import { DialogProps } from "@mui/material";
import { useTranslation } from "react-i18next";
import { TModalsIds } from "../../../../app/state/modalSlice/types";
import { ModalBasic } from "../../../../shared/components/ModalBasic";
import { AuthForm } from "../../../../features/Auth/AuthForm";
import { useModalSelectors } from "../../../../app/state/modalSlice/hook/use-modal-selectors";

interface Props extends Omit<DialogProps, "open"> {
  closeModal: (id: TModalsIds) => void;
}

export const AddUserModal = ({ closeModal, ...rest }: Props) => {
  const addUserModal = useModalSelectors("add_user_modal");
  const { t } = useTranslation();
  return (
    <ModalBasic
      open={addUserModal.isOpen}
      onClose={() => closeModal("add_user_modal")}
      {...rest}
    >
      <AuthForm btnText={t("header.add_user_button")} formLocation="app" />
    </ModalBasic>
  );
};
